// SPDX-License-Identifier: AGPL-3.0-or-later
import {makeAutoObservable} from 'mobx';

class KonvoCalendarBridge {
	ownedUntil = 0;
	changeVersion = 0;
	constructor() {
		makeAutoObservable(this);
	}
	get serverOwned(): boolean {
		return this.ownedUntil > Date.now();
	}
	setOwnership(owned: boolean, expiresAt?: string): void {
		const until = expiresAt ? Date.parse(expiresAt) : 0;
		this.ownedUntil = owned && Number.isFinite(until) ? until : 0;
	}
	invalidate(): void {
		this.changeVersion++;
	}
	reset(): void {
		this.ownedUntil = 0;
	}
}
export default new KonvoCalendarBridge();
